// Smooth-scroll helpers shared by the report navigation (ChapterNav) and the
// "jump to results when ready" effect. Both must honour the user's
// prefers-reduced-motion setting — falling back to an instant jump — so the
// motion preference is resolved in one place.

export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export function scrollToId(
  id: string,
  block: ScrollLogicalPosition = 'start',
): void {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    block,
  });
}
